import React, { useEffect, useRef, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { usePartnerContext } from '../components/Context/PartnerContext';
import { Container, Typography, TextField, Button, Box } from '@mui/material';
import { useNavigate } from 'react-router-dom';
const Activate = () => {
    const { Activate, validated, GeneratePassword, partners,pu } = usePartnerContext();
    
    const didFetch = useRef(false); 
    const query = useQuery();
    const token = query.get('token');
    const [password, setPassword] = useState('');
    const [userId, setUserID] = useState('');
    const [confirmPassword, setConfirmPassword] = useState('');
    const [error, setError] = useState('');
    const navigate = useNavigate();
    const handleSubmit = async (event) => {
       
        event.preventDefault();
        if (password !== confirmPassword) {
            setError('Passwords do not match.');
            return;
        }
     
      const resp=await  GeneratePassword(userId,password)
        if (resp === 'success') {
            navigate('/login');
        }
    }
    function useQuery() {
        return new URLSearchParams(useLocation().search);
    }
    const activatePartner = async (token) => { 
        
        const updatedPartners = await Activate(token);
        if (updatedPartners != null) {
            setUserID(updatedPartners[0].userID);
            console.log("Updated partners:", updatedPartners); // This will have the updated value
        }
    }

    useEffect(() => {
        if (!didFetch.current) {
             activatePartner(token);
          
            didFetch.current = true; // Mark the API call as done
        }
        
    });
    return (
        <div>
            {validated ==true && <Container maxWidth="sm">
                <Box sx={{ mt: 8 }}>
                    <Typography variant="h4" component="h1" gutterBottom>
                        Activate Your Account
                    </Typography>
                    <Box component="form" noValidate>
                        <TextField
                            margin="normal"
                            required
                            fullWidth
                            id="password"
                            label="Password"
                            type="password"
                            autoComplete="new-password"
                            onChange={(e) => setPassword(e.target.value)}
                            value={password}
                        />
                        <TextField
                            margin="normal"
                            required
                            fullWidth
                            id="confirm-password"
                            label="Confirm Password"
                            type="password"
                            autoComplete="new-password"
                            onChange={(e) => setConfirmPassword(e.target.value)}
                            value={confirmPassword}
                        />
                        {error && (
                            <Typography color="error" variant="body2">
                                {error}
                            </Typography>
                        )}
                        <Button
                            type="button"
                            fullWidth
                            variant="contained"
                            sx={{ mt: 3, mb: 2 }}
                            onClick={handleSubmit }
                        >
                            Activate
                        </Button>
                    </Box>
                </Box>
            </Container>}
            {validated == false &&<Container maxWidth="sm">
                <Box sx={{ mt: 8, textAlign: 'center' }}>
                    <Typography variant="h4" component="h1" gutterBottom>
                        Link Expired
                    </Typography>
                    <Typography variant="body1" gutterBottom>
                        Oops! It looks like this activation link has expired. Please request a new link to activate your account.
                    </Typography>
                  
                </Box>
            </Container> }
        </div>
    );
};

export default Activate;
